/**
* @ngdoc directive
* @name Custom Scroll
*
* @description
  Replaces default scrollbar with <a href="https://github.com/noraesae/perfect-scrollbar">Perfect Scrollbar</a>.
  Add attribute <code>custom-scroll</code> to positioned (not static) element.
  If element has width or height which is less than its content width or height it will add scroll inside it.
*
* @example
  <div custom-scroll style='position: relative;'>
    <div  style='width: 1000px; line-height: 50px'>
      Custom scroll example... Custom scroll example... Custom scroll example... Custom scroll example... Custom scroll example... Custom scroll example...
    </div>
  </div>
*/

app.directive('customScroll', ["$timeout", "$window", function ($timeout, $window) {
  return {
    restrict: 'A',
    link: function ($scope, $element, $attr) {
      var initScroll = function() {
        if ($attr.customScroll && $attr.customScroll !== 'true')
          return;
        Ps.initialize($element[0]);

        // set default values
        $scope.offsetMargin = $scope.offsetMargin || {};
        $scope.offsetWidth = $scope.offsetWidth || {};
        $scope.offsetMargin.maxWidth = $element[0].clientWidth ? $element[0].clientWidth : undefined;

        function updateStyles() {
          $scope.offsetMargin.marginLeft = '-' + $element[0].scrollLeft + 'px';
          $scope.offsetMargin.maxWidth = $element[0].scrollLeft + $element[0].clientWidth;
          $scope.offsetWidth.width = $element[0].scrollLeft + 'px';
          $scope.$apply($scope.offsetMargin);
        }

        var updateStylesDebounce = _.debounce(updateStyles, 10);

        /**
         * ps-scroll-x- scroll x event calculates data for sticky header
         */
        $element[0].addEventListener('ps-scroll-x', function () {
          updateStylesDebounce();
        });

        /**
         * calculate data for sticky header
         */
        angular.element($window).bind('scroll', function() {
          updateStylesDebounce();
        });
      };

      $timeout(initScroll, 0);
    }
  };
}]);



// WEBPACK FOOTER //
// ./~/ng-annotate-loader/loader.js!./project/components/customscrollDirective.js